import { CallToActionProps } from "../interfaces/interfaces.d";
export const callToActionData: Array<CallToActionProps> = [
    { 
        image:"",
        icon: <img src="img/carbon_money.png" alt="" />,
        title:" Money management ", 
        text:" Master your finances and achieve that good living you truly deserve",
        linkText:"Learn more",
        linkUrl:"money-management"
    },
    { 
        image:"",
        icon: <img src="img/fluent_savings-16-regular.png" alt="" />,
        title:" Smart Savings ", 
        text:" Savings made flexible, fun and easily hitting target goals seamlessly possible",
        linkText:"Learn more",
        linkUrl:"smart-savings"
    },
    { 
        image:"",
        icon: <img src="img/Vector (1).png" alt="" />,
        title:"Sublime Investment", 
        text:" Investments made simple and worth it, to match your financial standing and help you gradually build a fortune",
        linkText:"Learn more",
        linkUrl:"investment"
    },

]